import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginForm from "@/login/loginForm"
import Shop from"@/app/shop"
import lastArticle from"@/app/productListing/lastArticle"
const productDetails = () => import('@/app/productDetails/productDetails')
//import productDetails from "@/app/productDetails/productDetails"
import categoryOverview from "@/app/productListing/categoryOverview"
import categoryProduct from "@/app/productListing/categoryProduct"
import checkout from "@/app/cart/checkout"
import watchList from "@/app/productListing/watchList";
import deposit from "@/app/deposit";
import bottleDeposit from "@/app/deposit/bottleDeposit";
import depositActions from "@/app/deposit/depositActions";
import profile from "@/app/account/profile";
import userActions from "@/app/account/userSkeleton";
import orders from "@/app/account/orders";
import createUser from "@/app/admin/createUser";
import adminSkeleton from "@/app/admin/adminSkeleton";
import bottleDepositList from "@/app/deposit/bottleDepositList"
import store from "@/store";
import setPassword from "@/app/setPassword";
import singleOrder from "@/app/account/singleOrder";
//import editDeliveryDays from "@/app/admin/editDeliveryDays";
import imprint from "@/app/imprint";
import articleResults from "@/app/productListing/articleResults";
import axios from "axios";
import editUser from "@/app/admin/editUser";
import editDeliveryDaysCustomer from "@/app/admin/editDeliveryDaysCustomer";
import savedDeposits from "@/app/deposit/savedDeposits";
import savedDepositDetails from "@/app/deposit/savedDepositDetails";
import news from "@/app/news/news";
import labels from "@/app/label/labels";
import newArticles from "@/app/productListing/newArticles";
import inventoryCheckout from "@/app/inventory/inventoryCheckout";
import editInventoryDays from "@/app/inventory/editInventoryDays";
import inventories from "@/app/inventory/inventories";
import singleInventory from "@/app/inventory/singleInventory";
import discountedArticles from "@/app/productListing/discountedArticles.vue";
import mhdInventoryCheckout from "@/app/mhdinventory/mhdInventoryCheckout.vue";
import Invoices from "@/app/invoices/Invoices.vue";
import InvoiceDetails from "@/app/invoices/InvoiceDetails.vue";
import MissingItemsDetails from "@/app/invoices/MissingItemsDetails.vue";

import WeeklyTourData from "@/app/tourData/WeeklyTourData.vue";
import TourDetails from "@/app/tourData/TourDetails.vue";
import Tours from "@/app/tourData/Tours.vue";
import SavedTourData from "@/app/tourData/SavedTourData.vue";
import TourDocuments from "@/app/tourData/TourDocuments.vue";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: LoginForm
  },
  {
    path: '/imprint',
    name: 'Impressum',
    component: imprint
  },
  {
    path: '/shop',
    name: 'Shop',
    component: Shop,
    meta: {
      pwSet: true,
      eligibleShop: true,
    },
    children: [
      {
        path: 'home',
        name: 'LastArticle',
        component: lastArticle
      },
      {
        path: 'article/:id',
        name: 'Artikeldetails',
        component: productDetails
      },
      {
        path: 'categories/:id?',
        name: 'Artikelkategorien',
        component: categoryOverview,
      },
      {
        path: 'category/:id',
        name: 'Kategorieprodukte',
        component: categoryProduct
      },
      {
        path: 'watchlist',
        name: 'Watchlist',
        component: watchList
      },
      {
        path: 'newArticles',
        name: 'NewArticles',
        component: newArticles
      },
      {
        path: 'discountedArticles',
        name: 'DiscountedArticles',
        component: discountedArticles
      },
      {
        path: 'searchResults/:searchTerm',
        name: 'Artikelergebnisse',
        component: articleResults
      },
      {
        path: 'checkout',
        name: 'Checkout',
        component: checkout,
        props: true
      },
      {
        path: 'checkoutInventory',
        name: 'InventoryCheckout',
        component: inventoryCheckout
      },
      {
        path: 'mhdListTotal',
        name: 'MHDControlCheckout',
        component: mhdInventoryCheckout
      },
      {
        path: 'news',
        name: 'News',
        component: news
      },
      {
        path: 'labels',
        name: 'Labels',
        component: labels
      }
    ]
  },
  {
    path: '/deposit',
    name: 'Deposit',
    component: deposit,
    meta: {
      pwSet: true,
      eligibleDeposit: true
    },
    children: [
      {
        path: '',
        name: 'depositActions',
        component: depositActions,
      },
      {
        path: 'savedDeposits',
        name: 'savedDeposits',
        component: savedDeposits,
      },
      {
        path: 'savedDeposits/:id',
        name: 'savedDepositDetails',
        component: savedDepositDetails
      },
      {
        path: 'bottleDeposit',
        name: 'bottleDeposit',
        component: bottleDeposit,
        props: true
      },
      {
        path: 'bottleDepositList',
        name: 'bottleDepositList',
        component: bottleDepositList,
        props: true
      },
      {
        path: 'weekly-tour-data',
        name: '',
        component: Tours,
        children: [
          {
            path: '',
            name: 'weeklyTourData',
            component: WeeklyTourData,
            props: true
          },
          {
            path: 'tour-documents',
            name: 'tourDocuments',
            component: TourDocuments,
            props: true
          },
          {
            path: 'tour-details/:id',
            name: 'tourDetails',
            component: TourDetails,
            props: true
          },
          {
            path: 'saved-tour-data',
            name: 'savedTourData',
            component: SavedTourData,
            props: true
          }
        ]
      }
    ]
  },

  {
    path: '/user',
    name: 'UserSkeleton',
    component: userActions,
    meta: {
      pwSet: true,
    },
    children: [
      {
        path: 'profile',
        name: 'Benutzerprofil',
        component: profile,
      },
      {
        path: 'orders',
        name: 'Bestellungen',
        component: orders,
      },
      {
        path: 'invoices',
        name: 'Rechnungen',
        component: Invoices,
      },
      {
        path: 'invoices/:id',
        name: 'RechnungsDetails',
        component: InvoiceDetails,
      },
      {
        path: 'invoices/missingItems/:id',
        name: 'MissingItemsDetails',
        component: MissingItemsDetails,
      },
      {
        path: 'inventories',
        name: 'Inventuren',
        component: inventories,
      },
      {
        path: 'inventory/:id',
        name: 'Inventur',
        component: singleInventory,
        props: true
      },
      {
        path: 'order/:id',
        name: 'Bestelldetails',
        component: singleOrder,
      }
    ]
  },

  {
    path: '/setPassword',
    name: 'setPassword',
    component: setPassword,
    meta: {
     pwSet: false
    }
  },

  {
    path: '/admin',
    name: 'AdminSkeleton',
    component: adminSkeleton,
    meta: {
      pwSet: true,
      eligibleAdmin: true
    },
    children: [
      {
        path: 'createUser',
        name: 'createUser',
        component: createUser
      },
      {
        path: 'editUser',
        name: 'editUser',
        component: editUser
      },
      {
        path: 'editDeliveryDays',
        name: 'editDeliveryDays',
        component: editDeliveryDaysCustomer
      },
      {
        path: 'editInventoryDays',
        name: 'editInventoryDays',
        component: editInventoryDays
      },
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}


router.beforeEach((to, from, next) => {
    source.cancel()

    if(to.fullPath.indexOf('deposit') > -1 || to.fullPath.indexOf('invoice') > -1) {
      store.commit('setHeaderVisibility', false)
    }

    if(localStorage.getItem('token')) {
      let userToken = JSON.parse(localStorage.getItem('token'))
      if(userToken.expiration < new Date().toISOString()) {
        store.dispatch('logout')

        return 0
      }

      let currentDate = new Date();
      currentDate.setMinutes(currentDate.getMinutes() + 60);
      userToken['expiration'] = currentDate;
      localStorage.setItem('token', JSON.stringify(userToken))

      let restrictions = JSON.parse(localStorage.getItem('restrictions'))
      let user = JSON.parse(localStorage.getItem('user'))

      if(to.matched.some(record => record.meta.pwSet)) {
        if(!restrictions.pw) {
          next({name: 'setPassword'})
        }
        else {
          if(to.matched.some(record => record.meta.eligibleDeposit)) {
            if(user['role'] === 2 || user['role'] === 3) {
              next()
            }
            else {
              next(from)
            }
          }

          else if(to.matched.some(record => record.meta.eligibleShop)) {
            if(user['role'] === 1 || user['role'] === 3) {
              next()
            }
            else {
              next({name:'depositActions'})
            }
          }

          else if(to.matched.some(record => record.meta.eligibleDeposit)) {
            if(user['role'] === 2 || user['role'] === 3) {
              next()
            }
            else {
              next({name: 'LastArticle'})
            }
          }

          else if(to.matched.some(record => record.meta.eligibleAdmin)) {
            if (user['role'] === 3) {
              next()
            }
            else if (user['role'] === 1) {
              next({name: 'LastArticle'})
            }
            else if (user['role'] === 2) {
              next({name: 'depositActions'})
            }
          }

          else next()
        }
      }

      else if(to.matched.some(record => !record.meta.pwSet)) {
        if(to.name === 'Impressum') {
          next()
        }
        else if(restrictions.pw) {
          next({name: 'LastArticle'})
        }
        else {
          next()
        }
      }

      else {
        if(to.path === '/login' && localStorage.getItem('token')) next({name: 'LastArticle'})
        else next()
      }
    }

    else if(!localStorage.getItem('token')) {
      //store.commit('logout')
      if(to.name !== 'Login' && to.name !== 'Impressum') next({name: 'Login'})
      else next()
    }

})



export default router
